import InternalMenu from './InternalMenu';

export default InternalMenu;
